import { ChangeDetectorRef, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
//import { RutValidator } from 'ng9-rut';
//import { RutValidator } from 'ng2-rut';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';
import { ObservableInspService } from 'src/app/services/observable_insp';
import { PropiedadService } from 'src/app/services/propiedad.service';
import { UserService } from 'src/app/services/user.service';
import { map, startWith } from 'rxjs/operators';
var DireccionInspComponent = /** @class */ (function () {
    function DireccionInspComponent(_formBuilder, _userService, dialog, _snackBar, spinner, _changeDetector, 
    //private rutValidator: RutValidator,
    _router, observableService, _prop) {
        var _this = this;
        this._formBuilder = _formBuilder;
        this._userService = _userService;
        this.dialog = dialog;
        this._snackBar = _snackBar;
        this.spinner = spinner;
        this._changeDetector = _changeDetector;
        this._router = _router;
        this.observableService = observableService;
        this._prop = _prop;
        this.displayedColumns = ["rol", "direccion", "actions"];
        this.rol = new FormControl("");
        this.dir = new FormControl("");
        this.num = new FormControl("");
        this.lista_dir = new BehaviorSubject([]);
        this.dirs = [];
        this.btnContinuar = false;
        this.primeraBusqueda = false;
        this.segundoPaso = false;
        this.dires = [];
        this.buscarbtn = true;
        this.secondFormGroup = this._formBuilder.group({
            rol: this.rol,
            dir: this.dir,
            num: this.num,
        });
        this._prop.getCalles().subscribe(function (response) {
            _this.calles = response.calles;
            _this.bandera = true;
            _this.spinner.hide();
        }, function (error) {
            console.log(error);
            // this.spinner.hide()
        });
    }
    DireccionInspComponent.prototype.ngDoCheck = function () {
        this.segundoPaso = false;
        if (this.lista_dir.value.length > 0) {
            this.btnContinuar = true;
        }
        if (this.lista_dir.value.length > 0) {
            this.buscarbtn = false;
        }
        else {
            this.buscarbtn = true;
        }
    };
    DireccionInspComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dirs = [];
        //console.log('parametros en direccion ', this.info_rut);
        this.filteredOptions = this.secondFormGroup.controls.dir.valueChanges.pipe(startWith(''), map(function (value) { return _this._filter(value); }));
    };
    DireccionInspComponent.prototype._filter = function (value) {
        var filterValue = value.toLowerCase();
        return this.calles.filter(function (option) { return option.toLowerCase().indexOf(filterValue) === 0; });
    };
    DireccionInspComponent.prototype.buscar_info_propiedad_rol = function () {
        var _this = this;
        this._userService
            .traerInfo_propiedad_rol(this.secondFormGroup.controls.rol.value)
            .subscribe(function (response) {
            console.log(response);
            if (response.status == "error") {
                _this.secondFormGroup.controls.dir.setValue("");
                _this.secondFormGroup.controls.num.setValue("");
                _this.secondFormGroup.controls.rol.setValue("");
                swal({
                    type: "warning",
                    title: "Atención!",
                    text: response.message,
                    confirmButtonColor: "#3F51B5",
                    confirmButtonText: "Aceptar",
                    timer: 3500,
                }).then(function () { }, function (dismiss) {
                    if (dismiss === "timer") {
                    }
                });
            }
            else {
                if (response.dirs.length > 1) {
                    for (var i = 0; i < response.dirs.length; i++) {
                        var element = response.dirs[i];
                        _this.dires.push(element);
                    }
                    console.log(_this.dires);
                    _this.dialog.open(_this.direccionesDialog, { disableClose: true });
                    _this.spinner.hide();
                }
                else {
                    console.log("==LINEA 619 ===");
                    var rol_yaExiste = false;
                    if (_this.dirs.length <= 2) {
                        for (var i = 0; i < _this.dirs.length; i++) {
                            /* if (this.dirs[i].rol == response.rol) {
                              rol_yaExiste = true;
                            } */
                        }
                        if (!rol_yaExiste) {
                            //console.log("==LINEA 628 ===");
                            //console.log("response", response);
                            if (response !== 0) {
                                _this.dirs.splice(0);
                                //console.log('grabo data ', response.dirs, response.info);
                                //this.dirs.push(response.data.dirs);
                                //this.dirs.push(response.dirs);
                                _this.dirs[0] = response.dirs;
                            }
                            else {
                                //this.dirs.push(response.data.dirs);
                                //this.dirs.push(response.dirs);
                                _this.dirs[0] = response.dirs;
                                //console.log('grabo data iwal ', response);
                            }
                            _this.datosTotales = _this.dirs.map(function (dir) {
                                //return response.data.info
                                //console.log("113 dir:", dir)
                                return dir;
                            });
                            //console.log('datos resumidos ', this.datosTotales[0], response.info._PDI_Id_Direcc);
                            _this.observableService.folioDire$.emit(response.info._PDI_Id_Direcc);
                            _this.observableService.folioPredio$.emit(response.info._PDI_Folio_Propiedad);
                            //console.log("dirs", this.dirs, this.dirs[0]);
                            _this.lista_dir.next(_this.dirs[0]);
                            _this.btnContinuar = true;
                            _this.primeraBusqueda = true;
                            _this.dataCalle = _this.dirs[0].map(function (dir) {
                                console.log(dir);
                                return dir.direcCompleta;
                            });
                            /* this.dataNum = this.dirs.map((dir) => {
                              return dir[0].num
                            }); */
                            _this.direccionSolicitante = _this.dataCalle.toString(); //+ ' ' + this.dataNum.toString()
                            console.log('direccionSolicitante ', _this.direccionSolicitante);
                            _this.observableService.direccion$.emit(_this.direccionSolicitante);
                            _this._changeDetector.detectChanges();
                            _this.secondFormGroup.controls.dir.setValue("");
                            _this.secondFormGroup.controls.num.setValue("");
                            _this.secondFormGroup.controls.rol.setValue("");
                            if (_this.dirs[0].length > 0) {
                                _this.segundoPaso = true;
                            }
                        }
                        else {
                            //console.log("==LINEA 641 ===");
                            _this.secondFormGroup.controls.dir.setValue("");
                            _this.secondFormGroup.controls.num.setValue("");
                            _this.secondFormGroup.controls.rol.setValue("");
                            swal({
                                type: "warning",
                                title: "Atención!",
                                text: "El rol ingresado ya esta agregado",
                                confirmButtonColor: "#3F51B5",
                                confirmButtonText: "Aceptar",
                                timer: 3500,
                            }).then(function () { }, function (dismiss) {
                                if (dismiss === "timer") {
                                }
                            });
                        }
                    }
                    else {
                        console.log("==LINEA 662 ===");
                        _this.secondFormGroup.controls.dir.setValue("");
                        _this.secondFormGroup.controls.num.setValue("");
                        _this.secondFormGroup.controls.rol.setValue("");
                        _this._snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                            duration: 2000,
                        });
                    }
                }
            }
        }, function (error) {
            _this.secondFormGroup.controls.dir.setValue("");
            _this.secondFormGroup.controls.num.setValue("");
            _this.secondFormGroup.controls.rol.setValue("");
            swal({
                type: "error",
                title: "Ha ocurrido un error!",
                text: error._body,
                confirmButtonColor: "#3F51B5",
                confirmButtonText: "Aceptar",
                timer: 3500,
            }).then(function () { }, function (dismiss) {
                if (dismiss === "timer") {
                }
            });
        });
    };
    DireccionInspComponent.prototype.insertarDir = function () {
        var rol_yaExiste = false;
        if (this.dirs.length <= 2) {
            for (var i = 0; i < this.dirs.length; i++) {
                if (this.dirs[i].rol == this.dirSeleccionada.rol) {
                    rol_yaExiste = true;
                }
            }
            if (!rol_yaExiste) {
                console.log(this.dirSeleccionada);
                console.log("direccionesss", this.dirSeleccionada);
                var dir = {
                    calle: this.dirSeleccionada.calle,
                    num: this.dirSeleccionada.num,
                    direcCompleta: this.dirSeleccionada.direcCompleta,
                    rol: this.dirSeleccionada.rol,
                    folio: this.dirSeleccionada.folio,
                    iddirec: this.dirSeleccionada.iddirec
                    // info: this.dirrecciones.info,
                };
                this.dirs.push(dir);
                this.lista_dir.next(this.dirs);
                console.log(this.lista_dir);
                this._changeDetector.detectChanges();
                this.dataCalle = this.dirs.map(function (dir) {
                    console.log(dir);
                    return dir.direcCompleta;
                });
                this.direccionSolicitante = this.dataCalle.toString(); //+ ' ' + this.dataNum.toString()
                console.log('direccionSolicitante ', this.direccionSolicitante);
                this.observableService.folioDire$.emit(dir.iddirec);
                this.observableService.folioPredio$.emit(dir.folio);
                this.observableService.direccion$.emit(this.direccionSolicitante);
                this.secondFormGroup.controls.dir.setValue("");
                this.secondFormGroup.controls.num.setValue("");
                this.secondFormGroup.controls.rol.setValue("");
                if (this.dirs.length > 0) {
                    this.segundoPaso = true;
                }
                this.dialog.closeAll();
            }
            else {
                this.dialog.closeAll();
                this.secondFormGroup.controls.dir.setValue("");
                this.secondFormGroup.controls.num.setValue("");
                this.secondFormGroup.controls.rol.setValue("");
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'El rol ingresado ya esta agregado',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(function () {
                }, function (dismiss) {
                    if (dismiss === 'timer') {
                    }
                });
            }
        }
        else {
            this.dialog.closeAll();
            this.spinner.hide();
            this.secondFormGroup.controls.dir.setValue("");
            this.secondFormGroup.controls.num.setValue("");
            this.secondFormGroup.controls.rol.setValue("");
            this._snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                duration: 2000,
            });
        }
    };
    // eliminar_direccion(i) {
    //   console.log("eliminar direccion", this.dirs)
    //   var filter = this.dirs[0].filter((vale, index, arr) => {
    //     return index != i;
    //   });
    //   if (this.dirs[0].length == 1) {
    //     this.btnContinuar = false
    //   }
    //   this.dirs[0] = filter;
    //   this.lista_dir.next(this.dirs[0]);
    //   this.dataCalle = this.dirs[0].map((dir) => {
    //     //console.log(dir)
    //     return dir.direcCompleta
    //   });
    //   /* this.dataNum = this.dirs.map((dir) => {
    //     return dir[0].num
    //   }); */
    //   this.direccionSolicitante = this.dataCalle.toString() //+ ' ' + this.dataNum.toString()
    //   console.log('direccionSolicitante ', this.direccionSolicitante);
    //   this.observableService.direccion$.emit(this.direccionSolicitante);
    //   //console.log(i, this.dirs, this.dirs[0], this.dirs[0].length);
    //   //console.log(this.lista_dir.length)
    //   this._changeDetector.detectChanges();
    // }
    DireccionInspComponent.prototype.eliminar_direccion = function (i, item) {
        console.log(i);
        console.log(item);
        this.btnContinuar = false;
        this.segundoPaso = false;
        console.log(this.dirs);
        var filter = this.dirs.filter(function (vale, index, arr) {
            return index != i;
        });
        if (this.lista_dir.value.length > 0) {
            this.segundoPaso = true;
            this.segundoPaso = true;
        }
        this.dirs = filter;
        this.lista_dir.next(this.dirs);
        this._changeDetector.detectChanges();
    };
    DireccionInspComponent.prototype.buscar_info_propiedad_direccion = function () {
        var _this = this;
        var calle = "";
        calle = this.secondFormGroup.controls.dir.value;
        calle.toUpperCase();
        this._userService.traerInfo_propiedad_direccion(calle.toUpperCase(), this.secondFormGroup.controls.num.value)
            .subscribe(function (response) {
            console.log("entre en buscar por direccion", response);
            var dir_yaExiste = false;
            if (response.status == "error") {
                _this.secondFormGroup.controls.dir.setValue("");
                _this.secondFormGroup.controls.num.setValue("");
                _this.secondFormGroup.controls.rol.setValue("");
                swal({
                    type: "warning",
                    title: "Atención!",
                    text: response.message,
                    confirmButtonColor: "#3F51B5",
                    confirmButtonText: "Aceptar",
                    timer: 3500,
                }).then(function () { }, function (dismiss) {
                    if (dismiss === "timer") {
                    }
                });
            }
            else {
                if (response.dirs.length > 1) {
                    for (var i = 0; i < response.dirs.length; i++) {
                        var element = response.dirs[i];
                        _this.dires.push(element);
                    }
                    console.log(_this.dires);
                    _this.dialog.open(_this.direccionesDialog, { disableClose: true });
                    _this.spinner.hide();
                }
                else {
                    if (_this.dirs.length <= 2) {
                        for (var i = 0; i < _this.dirs.length; i++) {
                            /* console.log("dirs", this.dirs, this.dirs[i],response);
                            console.log("response::: ", this.dirs[i].calle," == ",response.calle," && ",this.dirs[i].num," == ",response.num);
                            if (this.dirs[i].calle == response.calle && this.dirs[i].num == response.num) {
                              dir_yaExiste = true;
                              console.log("este dio true response::: ", this.dirs[i].calle," == ",response.calle," && ",this.dirs[i].num," == ",response.num);
                            } */
                        }
                        if (!dir_yaExiste) {
                            _this.dirs.splice(0);
                            //this.dirs.push(response.dirs);
                            _this.dirs[0] = response.dirs;
                            /* if(this.dirs.length==1){
                              this.dirs.push(response.dirs);
                            } */
                            //console.log("response 290:", response.dirs, this.dirs[0])
                            _this.lista_dir.next(_this.dirs[0]);
                            _this.dataCalle = _this.dirs[0].map(function (dir) {
                                //console.log(dir)
                                return dir.direcCompleta;
                            });
                            /* this.dataNum = this.dirs.map((dir) => {
                              return dir[0].num
                            }); */
                            _this.direccionSolicitante = _this.dataCalle.toString(); //+ ' ' + this.dataNum.toString()
                            console.log('direccionSolicitante ', _this.direccionSolicitante);
                            _this.observableService.direccion$.emit(_this.direccionSolicitante);
                            _this.btnContinuar = true;
                            _this._changeDetector.detectChanges();
                            _this.secondFormGroup.controls.dir.setValue("");
                            _this.secondFormGroup.controls.num.setValue("");
                            _this.secondFormGroup.controls.rol.setValue("");
                            if (_this.dirs[0].length > 0) {
                                _this.segundoPaso = true;
                            }
                        }
                        else {
                            _this.secondFormGroup.controls.dir.setValue("");
                            _this.secondFormGroup.controls.num.setValue("");
                            _this.secondFormGroup.controls.rol.setValue("");
                            swal({
                                type: "warning",
                                title: "Atención!",
                                text: "La dirección ingresada ya esta agregada",
                                confirmButtonColor: "#3F51B5",
                                confirmButtonText: "Aceptar",
                                timer: 3500,
                            }).then(function () { }, function (dismiss) {
                                if (dismiss === "timer") {
                                }
                            });
                        }
                    }
                    else {
                        _this.secondFormGroup.controls.dir.setValue("");
                        _this.secondFormGroup.controls.num.setValue("");
                        _this.secondFormGroup.controls.rol.setValue("");
                        _this._snackBar.open("Ya tiene 3 direcciones agregadas", "Cerrar", {
                            duration: 2000,
                        });
                    }
                }
            }
        }, function (error) {
            console.log(error);
            _this.secondFormGroup.controls.dir.setValue("");
            _this.secondFormGroup.controls.num.setValue("");
            _this.secondFormGroup.controls.rol.setValue("");
            swal({
                type: "error",
                title: "Ha ocurrido un error!",
                text: error._body,
                confirmButtonColor: "#3F51B5",
                confirmButtonText: "Aceptar",
                timer: 3500,
            }).then(function () { }, function (dismiss) {
                if (dismiss === "timer") {
                }
            });
        });
    };
    return DireccionInspComponent;
}());
export { DireccionInspComponent };
